import { generateActions } from './utils'

// A list of all available actions for the teams collection. The array describes
// the arguments that are passed to the REQUEST action
export const definition = {
  readBySchedule: [ 'id' ]
}

export default generateActions(['TEAMS'], definition)
